import styled from "styled-components";
import SimplebarHeader from "../../Simplebar/SimplebarHeader";
import SimplebarContent from "../../Simplebar/SimplebarContent";
import SimplebarAction from "../../Simplebar/SimplebarAction";
import SimplebarWrapper from "../../Simplebar/SimplebarContainer";

// Stretches a sidebar simplebar to fill its dashboard grid cell: the list grows, header and action keep their size
const SimplebarWidgetContainer = styled.div`
  height: 100%;

  ${SimplebarWrapper} {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: white;
  }

  ${SimplebarHeader}, ${SimplebarAction} {
    flex-shrink: 0;
    background-color: white;
  }

  ${SimplebarContent} {
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
  }

  .dashboard-mobile & ${SimplebarContent} {
    min-height: 160px;
    max-height: 320px;
  }
`;

export default SimplebarWidgetContainer;
